module.exports = __webpack_public_path__ + "img/realTime.4a156ca6.png";